import { createContext, useContext } from "react";
import type { WeeklyQuestCard } from "../types/games";
import type { Rating } from "../types/rating";
import type { DateValue } from "../types/data";
import type { RatingProgressReward } from "../hooks/ratingMutationTypes";

export interface WeeklyQuestCardView extends WeeklyQuestCard {
  rarityLabel: string;
  rarityIcon: string;
  opened: boolean;
  selected: boolean;
  completed: boolean;
  progressCompleted: boolean;
  unavailable: boolean;
  progress: number;
  matchingFilm: Rating | null;
  selectedAt: number | null;
  completedAt: DateValue;
}

export interface WeeklyQuestActionResult {
  ok: boolean;
  message?: string;
  busy?: boolean;
  refreshed?: number;
}

export interface WeeklyQuestCardsContextValue {
  cards: WeeklyQuestCardView[];
  selectedQuests: WeeklyQuestCardView[];
  selectedQuestCount: number;
  activeQuests: WeeklyQuestCardView[];
  completedSelectedQuestCount: number;
  completedQuests: RatingProgressReward[];
  openCard: (cardId: string) => Promise<WeeklyQuestActionResult>;
  selectQuest: (cardId: string) => Promise<WeeklyQuestActionResult>;
  recalculateProgress: (options?: { automatic?: boolean }) => Promise<WeeklyQuestActionResult> | void;
  recalculating: boolean;
  canManage: boolean;
  loaded: boolean;
  settled: boolean;
  weekId: string;
  legendaryMisses: number;
  legendaryChance: number;
  legendaryCompletedCount: number;
  limits: { maxSelected?: number; maxOpened?: number };
}

const unavailableWeeklyQuestCards: WeeklyQuestCardsContextValue = {
  cards: [],
  selectedQuests: [],
  selectedQuestCount: 0,
  activeQuests: [],
  completedSelectedQuestCount: 0,
  completedQuests: [],
  openCard: async () => ({ ok: false, message: "Карты недели ещё загружаются" }),
  selectQuest: async () => ({ ok: false, message: "Карты недели ещё загружаются" }),
  recalculateProgress: () => undefined,
  recalculating: false,
  canManage: false,
  loaded: false,
  settled: false,
  weekId: "",
  legendaryMisses: 0,
  legendaryChance: 0,
  legendaryCompletedCount: 0,
  limits: {}
};

export const WeeklyQuestCardsContext = createContext(unavailableWeeklyQuestCards);

export const useWeeklyQuestCards = () => useContext(WeeklyQuestCardsContext);
